import UserForm from "../UserForm/UserForm"

const UserLogin = () => {
   return <UserForm formType={"login"} />
};

export default UserLogin;
